var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.5,
    height: 33.5,
    viewBox: "0 0 33.5 33.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#e62a32;stroke-miterlimit:10;stroke-width:1.5px;}.b{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.595 -2.754)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(3.345 3.504)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.782,
    cy: 1.782,
    r: 1.782,
    transform: "translate(17.563 17.721)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 2.425,
    x2: 6.005,
    transform: "translate(21.619 16.35)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 2.213,
    transform: "translate(19.345 6.63)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.522 19.504)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 2.213,
    transform: "translate(23.544)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 2.213
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.857 12.774)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.491,
    y1: 0.313,
    transform: "translate(20.604 13.147)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.491,
    y1: 0.313
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.934 8.34)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.294,
    y1: 0.502
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.481 8.284)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 0.505,
    x2: 0.29,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.918 12.68)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 0.317,
    x2: 0.488,
    transform: "translate(0 13.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 0.317,
    x2: 0.488,
    transform: "translate(20.485)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 2.213,
    transform: "translate(19.408 30.652)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.526 30.654)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 0.294,
    y2: 0.502
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.983 30.707)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.29,
    y2: 0.505
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 9.429,
    y2: 6.669,
    transform: "translate(7.732 12.116)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };